import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { UtilsService } from './shared/services/utils.service';
import { MatSidenav } from '@angular/material';

import { MENUITEMS } from './data/_MENUITEMS';
import {
  Router, Event, NavigationEnd, ActivatedRoute
} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  @ViewChild('snav', { static: true }) sidenav: MatSidenav;
  _MENUITEMS = MENUITEMS;
  dev = true;

  // tslint:disable-next-line:variable-name
  constructor(public _ui: UtilsService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,
    private _activeRoute: ActivatedRoute, private router: Router) {
    _ui.startListener(changeDetectorRef, media);
    _ui.sidenav = this.sidenav;

    //questo controllo viene fatto perchè al momento devo nascondere il menù quando mi trovo sulla home
    // router.events.subscribe((event: Event) => {
    //   if (event instanceof NavigationEnd) {
    //     if (event.url == "/") {
    //       this.dev = false;
    //     } else {
    //       this.dev = true;
    //     }
    //   }
    // });
  }



  ngOnInit() {
    this._ui.sidenav = this.sidenav;
    localStorage.getItem('langSelected') ? this._ui.langSelected = localStorage.getItem('langSelected') : this._ui.langSelected = 'IT';
    this._activeRoute.queryParams.subscribe(result => result.dev == 1 ? this.dev = true : 'nothing');
  }


  ngOnDestroy(): void {
    this._ui.destoryListener();
  }
}
